<template>
  <article-card-generic class="category-card">
    <h3 class="title">{{ category.title }}</h3>
    <cms-components-rich-text class="description" :text="category.description" />
    <NuxtLink class="no-link" no-prefetch :to="slug">
     Accéder à la catégorie
    </NuxtLink>
  </article-card-generic>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      required: true
    },
    parentCategorySlug: {
      type: String,
      default: ''
    }
  },
  computed: {
    slug() {
      return this.parentCategorySlug.length > 0 ? `/${this.parentCategorySlug}/${this.category.slug}` : this.category.slug
    }
  }
}
</script>


<style lang="less" scoped>
.category-card {
  justify-content: space-between;
  height: 185px;
  width: 260px;
  padding: 24px;
}

.title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  font-weight: var(--ds-weight-semi-bold);
  font-size: 16px;
  color: var(--ds-color-gray-100);
  text-transform: uppercase;

  margin: 0;
}

.description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  height: 64px;
  overflow: hidden;

  font-weight: 400;
  font-size: 14px;
  color: var(--ds-color-gray-50);

  :deep(strong) {
    font-weight: normal;
  }
}

.no-link {
  font-weight: 500;
  font-size: 14px;
  color: var(--ds-color-primary-100);
}

</style>

